var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWsBaby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 238.9",
    style: {
      enableBackground: "new 0 0 300 238.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FFCF4D;}\r\n\t.st2{fill:#BFD7ED;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-178.2887,27.005415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "matrix(0.26458333,0,0,0.26458333,13.201221,-61.775891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path861",
    className: "st0",
    d: "M-1022.8-194.3h-66.6v39.5h113.6v46.9h-113.6v79.4h-55.3v-212.6h121.9V-194.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path863",
    className: "st0",
    d: "M-899.4-65.4h-78.9L-991-28.5h-58.9l81-212.6h60.3l80.9,212.6h-59L-899.4-65.4z M-914-107.4 l-24.8-70.9l-24.8,70.9H-914z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path865",
    className: "st0",
    d: "M-582.8-28.5h-68.7l-52.7-81.8v81.8h-55.3v-212.6h85.9c10.6-0.2,21.1,1.5,31,5.2 c16.2,6,29,18.8,34.8,35.1c3,8.2,4.4,16.8,4.4,25.5c0,16.2-3.9,29.3-11.7,39.3c-7.8,10.1-19.3,16.9-34.5,20.4L-582.8-28.5z  M-704.3-146.1h10.3c10.9,0,19.3-2.2,25.1-6.8c6-4.6,9.3-11.9,8.9-19.4c0.4-7.5-2.8-14.8-8.8-19.4c-5.7-4.5-14.2-6.8-25.1-6.8 h-10.4L-704.3-146.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon867",
    className: "st0",
    points: "-800,-28.5 -784.8,-28.5 -784.8,-241.1 -840.1,-241.1 -840.1,-133.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g896",
    transform: "matrix(0.26458333,0,0,0.26458333,53.868978,26.297701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path888",
    className: "st1",
    d: "M-740.8,416.4h-66.6v39.5h113.6v46.9h-113.6v79.4h-55.3V369.6h121.9V416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path890",
    className: "st1",
    d: "M-617.4,545.4h-78.9l-12.7,36.9H-768l81-212.6h60.3l80.9,212.6h-59L-617.4,545.4z M-632.1,503.3 l-24.8-70.9l-24.8,70.9H-632.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path892",
    className: "st1",
    d: "M-300.8,582.2h-68.7l-52.7-81.8v81.8h-55.3V369.6h85.9c10.6-0.2,21.1,1.5,31,5.2 c16.2,6,29,18.8,34.8,35.1c3,8.2,4.4,16.8,4.4,25.5c0,16.2-3.9,29.3-11.7,39.3c-7.8,10.1-19.3,16.9-34.5,20.4L-300.8,582.2z  M-422.3,464.6h10.3c10.9,0,19.3-2.2,25.1-6.8c6-4.6,9.3-11.9,8.9-19.4c0.4-7.5-2.8-14.8-8.8-19.4c-5.7-4.5-14.2-6.8-25.1-6.8 h-10.4L-422.3,464.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon894",
    className: "st1",
    points: "-558.1,477 -518,582.2 -502.8,582.2 -502.8,369.6 -558.1,369.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g970",
    transform: "matrix(0.26458333,0,0,0.26458333,178.2887,-37.773956)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle944",
    className: "st2",
    cx: 136.1,
    cy: 492.3,
    r: 136.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle946",
    className: "st2",
    cx: 898.9,
    cy: 807.8,
    r: 136.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle948",
    className: "st2",
    cx: 272.1,
    cy: 803.5,
    r: 103.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle950",
    className: "st2",
    cx: 898.9,
    cy: 176.8,
    r: 136.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle952",
    className: "st2",
    cx: 272.1,
    cy: 185,
    r: 103.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle954",
    className: "st2",
    cx: 1030.7,
    cy: 492.3,
    r: 103.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path956",
    className: "st2",
    d: "M582.5,286.2c-113.7,0-206.1,92.4-206.1,206.1s92.4,206.1,206.1,206.1s206.1-92.4,206.1-206.1S696.5,286.2,582.5,286.2L582.5,286.2z M581.4,597.4c-57,0-103.2-46.2-103.2-103.2c0-57,46.2-103.2,103.2-103.2c57,0,103.2,46.2,103.2,103.2S638.4,597.4,581.4,597.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path958",
    className: "st2",
    d: "M430.6,340c-13.9-12.5-27.5-25.2-41.1-38l-40.8-38.3c-13.6-12.8-28.1-24.7-40.5-38.8c-12.8-13.9-24.7-28.1-36-43.7l0.9-0.9c15.6,10.8,29.8,23,43.7,36c13.9,12.8,26.1,26.9,38.8,40.5l38.3,40.8c12.8,13.9,25.5,27.5,38,41.1L430.6,340z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path960",
    className: "st2",
    d: "M734.5,339.2c12.5-13.9,25.2-27.5,38-41.1l38.3-40.8c12.8-13.6,24.7-28.1,38.8-40.5c13.9-12.8,28.1-24.7,43.7-36l0.9,0.9c-10.8,15.6-23,29.8-36,43.7c-12.8,13.9-26.9,26.1-40.5,38.8l-40.8,38.6c-13.9,12.8-27.5,25.5-41.1,38L734.5,339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path962",
    className: "st2",
    d: "M127.8,492c20.1-3.4,40.5-4.5,60.1-5.7c20.1-0.9,40.5,0.9,60.1,1.1l60.1,1.7c20.1,0.9,40.5,1.7,60.1,2.6v1.1c-20.1,0.9-40.5,1.7-60.1,2.6l-60.1,1.7c-20.1,0.3-40.5,2-60.1,1.1c-20.1-0.9-40.5-2-60.1-5.7C127.8,492.3,127.8,492,127.8,492L127.8,492z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path964",
    className: "st2",
    d: "M795.7,492c20.1-0.9,40-1.7,60.1-2.6l60.1-1.7c20.1-0.3,40.5-2,60.1-1.1c20.1,0.9,40.5,2,60.1,5.7v1.1c-20.1,3.4-40.5,4.5-60.1,5.7c-20.1,0.9-40.5-0.9-60.1-1.1l-60.1-1.7c-20.1-0.9-40.5-1.7-60.1-2.6V492z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path966",
    className: "st2",
    d: "M735.6,644.5c13.9,12.5,27.5,25.2,41.1,38l40.8,38.3c13.6,12.8,28.1,24.7,40.5,38.8c12.8,13.9,24.7,28.1,36,43.7l-0.9,0.9c-15.6-10.8-29.8-23-43.7-36c-13.9-13-26.1-26.9-38.8-40.5l-38.3-40.8c-12.8-13.9-25.5-27.5-38-41.1L735.6,644.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path968",
    className: "st2",
    d: "M431.2,645.3c-12.5,13.9-25.2,27.5-38,41.1l-38.3,40.8c-12.8,13.6-24.7,28.1-38.8,40.5c-13.9,12.8-28.1,24.7-43.7,36l-0.9-0.9c10.8-15.6,23-29.8,36-43.7c12.8-13.9,26.9-26.1,40.5-38.8l40.8-38.3c13.9-12.8,27.5-25.5,41.1-38L431.2,645.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsBaby);
export default __webpack_public_path__ + "static/media/ws-baby.84e0340f7a3f7da788eba2e6b72bc02d.svg";
export { ForwardRef as ReactComponent };